export const formatCPF = (value: string): string => {
    const numbers = value.replace(/\D/g, '');
    if (numbers.length <= 3) return numbers;
    if (numbers.length <= 6) return `${numbers.slice(0, 3)}.${numbers.slice(3)}`;
    if (numbers.length <= 9) return `${numbers.slice(0, 3)}.${numbers.slice(3, 6)}.${numbers.slice(6)}`;
    return `${numbers.slice(0, 3)}.${numbers.slice(3, 6)}.${numbers.slice(6, 9)}-${numbers.slice(9, 11)}`;
};

export const removeCPFMask = (value: string): string => {
    return value.replace(/\D/g, '');
};

export const isValidCPFLength = (cpf: string): boolean => {
    const numbers = removeCPFMask(cpf);
    return numbers.length === 11;
};

export const isValidCPF = (cpf: string): boolean => {
    const numbers = removeCPFMask(cpf);
    if (numbers.length !== 11) return false;
    if (/^(\d)\1+$/.test(numbers)) return false;
    let sum = 0;
    for (let i = 0; i < 9; i++) {
        sum += parseInt(numbers[i]) * (10 - i);
    }
    let remainder = sum % 11;
    const digit1 = remainder < 2 ? 0 : 11 - remainder;
    if (digit1 !== parseInt(numbers[9])) return false;
    sum = 0;
    for (let i = 0; i < 10; i++) {
        sum += parseInt(numbers[i]) * (11 - i);
    }
    remainder = sum % 11;
    const digit2 = remainder < 2 ? 0 : 11 - remainder;
    return digit2 === parseInt(numbers[10]);
};

export const generateRandomCPF = (): string => {
    const numbers = Array.from({ length: 9 }, () => Math.floor(Math.random() * 10));
    let sum = 0;
    for (let i = 0; i < 9; i++) {
        sum += numbers[i] * (10 - i);
    }
    let remainder = sum % 11;
    const digit1 = remainder < 2 ? 0 : 11 - remainder;
    numbers.push(digit1);
    sum = 0;
    for (let i = 0; i < 10; i++) {
        sum += numbers[i] * (11 - i);
    }
    remainder = sum % 11;
    const digit2 = remainder < 2 ? 0 : 11 - remainder;
    numbers.push(digit2);
    const cpfString = numbers.join('');
    return formatCPF(cpfString);
};
